<template>
  <section class="custom-matrix-vehicle-wrapper">
    <!-- Listing -->
    <div v-show="loading?.adasmatrices" class="listingWrapper">
      <div class="custom-spinner"><i class="fas fa-spinner fa-spin"></i></div>
    </div>
    <div v-show="!loading.adasmatrices" ref="listingWrapper" class="listingWrapper">
      <z-table
        v-model="adasmatrices"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        sort-on="sort"
        sort-dir="asc"
        :columns="tableColumnsName"
        :detail-column-class="detailColumnClass"
        :is-header-fixed="true"
        @sort="setOrder"
      >
        <template #tbody="props">
          <td class="custom-column-60">
            <a href="#" @click="showAdasMatrix(props.row)">show</a>
          </td>
          <td>{{ props.row.adasChecklistMatrixName }}</td>
          <td>{{ props.row.vehicleModel }}</td>
          <td class="custom-column-60">{{ props.row.yearStart }}</td>
          <td class="custom-column-60">{{ props.row.yearEnd }}</td>
          <td>{{ props.row.system }}</td>
          <td>{{ props.row.location }}</td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
    <dialog-matrix v-model="actionMatrix" @closing="closeModal" @saved="savedMakeMatrix" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTable from '@/components/utilities/elements/Table.vue'
import DialogMatrix from './dialog-make-matrix.vue'
export default {
  name: 'AdasMatrixVehicle',
  components: {
    ZTable,
    DialogMatrix
  },
  props: {
    vehicleMake: Number
  },
  data() {
    return {
      showInactive: false,
      orderBy: 'matrixItem',
      sortBy: 'asc',
      actionMatrix: null,
      detailColumnClass: 'custom-column-60'
    }
  },
  emits: ['refresh'],
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'lookups', 'adasmatrices']),
    tableColumnsName() {
      return [
        {
          field: 'adasChecklistMatrixVehicle',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'adasChecklistMatrixName',
          label: 'Category',
          sortable: true
        },
        {
          field: 'vehicleModel',
          label: 'Model',
          sortable: true
        },
        {
          field: 'yearStart',
          label: 'Start',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'yearEnd',
          label: 'End',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'system',
          label: 'System',
          sortable: true
        },
        {
          field: 'location',
          label: 'Location',
          sortable: true
        }
      ]
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['getAdasExclusions', 'getKeywords', 'getAdasMakeMatrix']),
    closeModal() {
      this.actionMatrix = null
    },
    setOrder(column, sortBy) {
      this.orderBy = column.field
      this.sortBy = sortBy
      console.log('Refreshing Matrix by Vehicle', {
        sortBy: this.sortBy,
        orderBy: this.orderBy
      })
      this.$emit('refresh', {
        sortBy: this.sortBy,
        orderBy: this.orderBy
      })
    },
    async showAdasMatrix(matrix) {
      console.log('Showing Make Matrix', matrix)
      await this.getKeywords({
        keys: ['CCCKeywordsLine', 'CCCKeywordsLocation', 'CCCKeywordsSublet'],
        vehicleMake: this.vehicleMake
      })
      this.getAdasMakeMatrix(matrix.adasChecklistMatrixVehicle)
      this.actionMatrix = {
        type: 'EDIT',
        subtitle: matrix.adasChecklistMatrixName
      }
    },
    async savedMakeMatrix() {
      this.actionMatrix = null
      this.$emit('refresh', {
        sortBy: this.sortBy,
        orderBy: this.orderBy
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-matrix-vehicle-wrapper {
  width: 100%;
}
.listingWrapper {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 580px;
  width: 100%;
}
.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}
</style>
